import { render, staticRenderFns } from "./BaseAddressVertify.vue?vue&type=template&id=603226d4&scoped=true&"
import script from "./BaseAddressVertify.vue?vue&type=script&lang=js&"
export * from "./BaseAddressVertify.vue?vue&type=script&lang=js&"
import style0 from "./BaseAddressVertify.vue?vue&type=style&index=0&id=603226d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603226d4",
  null
  
)

export default component.exports